import * as React from 'react';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import TaxonomyThemeTeaser from './Teaser';
import TaxonomyThemePage from './Page';
import type { TaxonomyTheme } from '../../../types/uncinc_profile/taxonomy';

type ThemeViewmode = 'teaser' | 'page' | 'title';

interface ThemeProps {
  entity: ImmutableEntity<TaxonomyTheme>;
  viewMode: ThemeViewmode;
}

const TaxonomyThemeWrapper: React.FC<ThemeProps> = ({ entity, viewMode, ...props }) => {
  switch (viewMode) {
    case 'teaser':
      return <TaxonomyThemeTeaser entity={entity} {...props} />;
    case 'page':
    default:
      return <TaxonomyThemePage entity={entity} {...props} />;
  }
};

export default TaxonomyThemeWrapper;
